import Chart from '@/components/Chart'

export default {
  components: {
    Chart,
  },
  props: {
    data: {
      required: true,
    },
  },
  computed: {
    maxValue() {
      let maxValue = 0
      if (this.data) {
        this.data.forEach(series => {
          series.forEach(value => {
            maxValue = Math.max(maxValue, value ? value.y : 0)
          })
        })
      }
      return maxValue
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0,
        },
        scales: {
          xAxes: [{
            type: 'time',
            gridLines: {
              z: 1,
            },
            time: {
              tooltipFormat: 'YYYY-MM-DD HH:mm',
              displayFormats: {
                minute: 'HH:mm',
                hour: 'HH:mm',
                day: 'MMM D',
              }
            },
            ticks: {
              beginAtZero: true,
              stepSize: 1000,
              maxRotation: 0,
              maxTicksLimit: 6,
            },
          }],
          yAxes: [{
            ticks: {
              min: 0,
              suggestedMax: this.maxValue,
              beginAtZero: true,
            },
            gridLines: {
              z: 1,
            },
          }]
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
      }
    },
  },
}
